import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Blog.css';
import { useNavigate } from 'react-router-dom';
import { slugify } from '../utils/slugify';
import SEO from '../components/SEO';

const Blog = () => {
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleBack = () => {
    setSelectedBlog(null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedBlog]);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get('https://api.sofiasurgicals.com/api/get-all-blog');
      setBlogs(response.data);
    } catch (error) {
      console.error('Failed to fetch blogs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const getImageUrl = (imagePath) => {
    return imagePath ? `https://api.sofiasurgicals.com/${imagePath}` : '/default-blog.jpg';
  };

  const handleReadMore = (blog) => {
    navigate(`/blogs/${slugify(blog?.slug || blog?.title)}`, { state: { blog } });
  };

  return (
    <div className="blog-section">
      <SEO
        title="Orthopaedic & Surgical Insights Blog"
        description="Read the latest articles, surgical guides, clinical insights, and product updates from Sofia Surgicals India."
        keywords="orthopaedic blog, trauma implants articles, surgical guides, spine implant insights, sofia surgicals blog"
        url="/blogs"
      />
      <h2 className="blog-title">Sofia Surgical Blog</h2>

      {loading ? (
        <p>Loading blogs...</p>
      ) :
        // !selectedBlog ? (
        <div className="blog-list">
          {blogs.length === 0 ? (
            <p>No blogs found.</p>
          ) : (
            blogs.map((blog) => (
              <div
                key={blog._id}
                className="blog-card"
                onClick={() => handleReadMore(blog)}
              >
                <img
                  src={getImageUrl(blog.image)}
                  alt={blog.title}
                  className="blog-img"
                />
                <div className="blog-card-body">
                  <h4>{blog.title}</h4>
                  <p>{blog.snippet}</p>
                  <span className="read-more">Read More →</span>
                </div>
              </div>
            ))
          )}
        </div>
        // ) : (
        //   <div className="blog-detail">
        //     <button onClick={handleBack} className="back-btn">← Back to All Blogs</button>
        //     <h3>{selectedBlog.title}</h3>
        //     <img
        //       src={getImageUrl(selectedBlog.image)}
        //       alt={selectedBlog.title}
        //       className="blog-detail-img"
        //     />
        //     <div dangerouslySetInnerHTML={{ __html: selectedBlog.content }} />
        //   </div>
        // )
      }
    </div>
  );
};

export default Blog;
